import React from 'react';
import { Tabs, Tab } from '@mui/material';
// import { useTranslation } from 'react-i18next';
import { useTranslation } from '../../hooks/useTranslation';

function SalesTabs({ activeTab, onTabChange }) {
   const { t } = useTranslation();
 
  return (
    <Tabs
      value={activeTab}
      onChange={onTabChange}
      sx={{ 
        borderBottom: 1, 
        borderColor: 'divider',
        mb: 0.5,
        minHeight: 36,
        '& .MuiTab-root': {
          textTransform: 'none',
          fontWeight: 500,
          minWidth: 120,
          py: 0.5,
          minHeight: 36,
        }
      }}
    >
      <Tab label={t('Sales.All_Invoices')} value={0} />
      <Tab label={t('Sales.Draft_Invoices')} value={1} />
    </Tabs>
  );
}

export default React.memo(SalesTabs); 